import { Button, Modal } from "@/components";
import React, { useMemo } from "react";

type ConfirmType = "create" | "update" | "delete";

type CreateModalProps = {
  type: ConfirmType;
  title?: string;
  confirmation?: React.ReactNode;
  open?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm(): void;
  isPending?: boolean;
  titleBtnConfirm?: string;
};

const ConfirmModal: React.FC<CreateModalProps> = ({
  type,
  title,
  confirmation,
  open,
  onOpenChange,
  onConfirm,
  isPending,
  titleBtnConfirm,
}) => {
  // Default title and confirmation message based on type
  const [_title, _confirmation] = useMemo(() => {
    let defaultTitle;
    let defaultConfirmation;

    switch (type) {
      case "create":
        defaultTitle = "新規作成を確認しますか？";
        defaultConfirmation =
          "本当に新規作成しますか？この操作は元に戻せません。";
        break;
      case "update":
        defaultTitle = "更新を確認しますか？";
        defaultConfirmation = "本当に更新しますか？この操作は元に戻せません。";
        break;
      case "delete":
      default:
        defaultTitle = "完全に削除しますか？";
        defaultConfirmation = (
          <div>
            本当に完全に削除しますか？
            <br />
            ご注意ください：この操作によりデータは完全に削除され、復元できません。
          </div>
        );
        break;
    }

    return [title || defaultTitle, confirmation || defaultConfirmation];
  }, [type, title, confirmation]);

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={_title}>
      <div className="text-sm leading-[1.375rem] border-grey-300">
        {_confirmation}
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button
          buttonType="text"
          onClick={() => onOpenChange(false)}
          className="!h-12"
        >
          キャンセル
        </Button>
        <Button
          variant="solid"
          color={type === "delete" ? "danger" : "primary"}
          className="!h-12"
          onClick={onConfirm}
          isLoading={isPending}
        >
          {titleBtnConfirm || (type === "delete" ? "完全に削除" : "確認")}
        </Button>
      </div>
    </Modal>
  );
};

export { ConfirmModal };
